import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    setEnderecos: ["payload"],
    setRota: ["payload"],
});

export const INITIAL_STATE = {
    excluidos: [],
    enderecos: [],
    tipo: "",
    rota: {},
};

const setEnderecos = (state = INITIAL_STATE, action) => ({
    ...state,
    enderecos: action.payload.enderecos,
    tipo: action.payload.tipo,
    excluidos: action.payload.excluidos,
});

const setRota = (state = INITIAL_STATE, action) => ({
    ...state,
    rota: action.payload,
});

export default createReducer(INITIAL_STATE, {
    [Types.SET_ENDERECOS]: setEnderecos,
    [Types.SET_ROTA]: setRota,
});
